/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Execution_Type_LabelInputs */

const fr_execution_type_label = /** @type {(inputs: Execution_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type d'exécution`)
};

/**

* @param {Execution_Type_LabelInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const execution_type_label = /** @type {((inputs?: Execution_Type_LabelInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Execution_Type_LabelInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_execution_type_label(inputs)
});